export default __webpack_public_path__ + "static/media/immediateHiring.68094761.svg";